import { Component } from "@angular/core"
import { AlertController, ViewController, ModalController, LoadingController, NavParams } from "ionic-angular"

import firebase from "firebase"

import { UserService } from "../../services/user"
import { UseTermsPage } from "./use-terms"

@Component({
  selector: "register-finish-page",
  templateUrl: "finish.html",
})
export class RegisterFinishPage {

  user: any = {}
  passwordConf = ""

  constructor(
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
    private viewCtrl: ViewController,
    private loadingCtrl: LoadingController,
    private navParams: NavParams
  ) {

    this.user = this.navParams.get("user")
  }

  onCancel() {

    this.viewCtrl.dismiss()
  }

  onFinish() {

    if (!this.validData())
      return

    const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

    loading.present()

    let newUser: any = {}

    firebase.auth().createUserWithEmailAndPassword(this.user.email, this.user.password)
      .then((createdUser) => {

        const { firstName, lastName, email, occupation, ddd, phone } = this.user

        newUser = {
          uid: createdUser.uid,
          firstName,
          lastName,
          email,
          occupation,
          ddd,
          phone,
          social: { facebook: "", twitter: "", linkedin: "" },
        }

        return firebase.database().ref(`users/${newUser.uid}`).set(newUser)
      })
      .then(() => UserService.updateUserData(newUser))
      .then(() => firebase.auth().signInWithEmailAndPassword(this.user.email, this.user.password))
      .then(() => {

        loading.dismiss()
        this.viewCtrl.dismiss()
      })
      .catch((error) => {

        console.log(error)

        loading.dismiss()

        this.alertCtrl.create({
          message: "Falha ao finalizar cadastro",
          buttons: ["Ok"]
        }).present()
      })
  }

  validData() {

    let message = ""
    let isOk = true

    if (!this.user.occupation || !this.user.ddd || !this.user.phone) {
      message = "Por favor informe seus dados profissionais"
    } else if (!this.user.password) {
      message = "Por favor defina uma senha de acesso"
    } else if (this.user.password.length < 6) {
      message = "Sua senha deve possuir ao menos 6 caracteres"
    } else if (!this.passwordConf) {
      message = "Por favor confirme sua senha"
    } else if (this.user.password != this.passwordConf) {
      message = "Senha não confirmada corretamente"
    }

    if (message) {
      isOk = false
      this.alertCtrl.create({
        message,
        buttons: ["Ok"]
      }).present()
    }

    return isOk
  }

  onShowUseTerms() {

    this.modalCtrl.create(UseTermsPage).present()
  }
}



// WEBPACK FOOTER //
// ./src/pages/register/finish.ts